import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2 } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function Services() {
  useDocumentMeta('Firearm Services & In-Store Support | Kjergaard Sports', 'Get practical in-person help, firearm selection guidance, scope installation, and in-store support at Kjergaard Sports in Lake Benton, Minnesota.');
  return <div data-id="element-742">
      <PageHero title="Services & In-Store Support" image="https://cdn.magicpatterns.com/uploads/6uBKPbVFcv4swNygT9aBpc/services-gunsmithing-workshop.jpg" alt="Gunsmithing workshop at Kjergaard Sports — lathe and shop tools" data-id="element-743" />

      <section className="py-20 bg-brand-offwhite" data-id="element-744">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-745">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-746">
            <div data-id="element-747">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-748">
                Real Help from Real People
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-749">
                At Kjergaard Sports, we believe that buying a firearm or
                outfitting for a hunt requires more than just a checkout button.
                We provide practical, in-person support to ensure you get the
                right equipment and understand how to use it safely.
              </p>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-750">
                Our experienced staff is here to answer your questions, help you
                mount that new scope, or guide you through the process of
                selecting your first firearm.
              </p>
            </div>

            <div data-id="element-751">
              <img src="https://cdn.magicpatterns.com/uploads/6uBKPbVFcv4swNygT9aBpc/services-gunsmithing-workshop.jpg" alt="In-store service at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-752" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-753">
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-754">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-6" data-id="element-755">
                Everyday Services
              </h3>
              <ul className="space-y-4" data-id="element-756">
                <li className="flex items-start" data-id="element-757">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-758" />
                  <span className="text-brand-charcoal/90" data-id="element-759">
                    Firearm selection help and fitting
                  </span>
                </li>
                <li className="flex items-start" data-id="element-760">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-761" />
                  <span className="text-brand-charcoal/90" data-id="element-762">
                    Scope mounting and boresighting
                  </span>
                </li>
                <li className="flex items-start" data-id="element-763">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-764" />
                  <span className="text-brand-charcoal/90" data-id="element-765">
                    Accessory installation questions
                  </span>
                </li>
                <li className="flex items-start" data-id="element-766">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-767" />
                  <span className="text-brand-charcoal/90" data-id="element-768">
                    Basic cleaning and maintenance advice
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-769">
              <h3 className="text-2xl font-serif text-brand-charcoal mb-6" data-id="element-770">
                Specialized Support
              </h3>
              <ul className="space-y-4" data-id="element-771">
                <li className="flex items-start" data-id="element-772">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-773" />
                  <span className="text-brand-charcoal/90" data-id="element-774">
                    Gunsmithing / repair support (call to confirm)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-775">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-776" />
                  <span className="text-brand-charcoal/90" data-id="element-777">
                    NFA / Form 4 in-store support (call to confirm)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-778">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-779" />
                  <span className="text-brand-charcoal/90" data-id="element-780">
                    Appraisals for trades or collections
                  </span>
                </li>
                <li className="flex items-start" data-id="element-781">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-782" />
                  <span className="text-brand-charcoal/90" data-id="element-783">
                    Transfers and regulated services
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-brand-cream border-l-4 border-brand-leather p-6" data-id="element-784">
            <p className="text-brand-charcoal/90 text-sm leading-relaxed" data-id="element-785">
              <strong data-id="element-786">Note:</strong> All firearm-related sales, transfers, and
              regulated services are handled strictly in-store and in accordance
              with applicable federal, state, and local laws. Please call ahead
              to confirm availability of specific gunsmithing or NFA services.
            </p>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-787" />
    </div>;
}